import { Card } from "antd";
import { useParams } from "react-router-dom";

import EdgeLogs from "@src/components/EdgeLogs/EdgeLogs";
import CameraHealth from "@src/components/SystemHealth/CameraHealth";
import OpcuaHealth from "@src/components/SystemHealth/OpcuaHealth";

const AssetAdmin = () => {
  const { assetId } = useParams<{ assetId: string }>();

  if (!assetId) {
    return <div>Asset ID is required to view this page.</div>;
  }

  return (
    <>
      <Card title="Edge Logs" bordered={false} style={{ marginTop: "20px" }}>
        <EdgeLogs assetId={assetId} />
      </Card>

      <div style={{ marginTop: "20px" }}>
        <OpcuaHealth assetId={assetId} />
      </div>

      <div style={{ marginTop: "20px" }}>
        <CameraHealth assetId={assetId} />
      </div>
    </>
  );
};

export default AssetAdmin;
